import type { Customer } from '~/types/adamTypes';

export type UseCategoryCustomer = {
  customerCategory: ComputedRef<Customer>;
  hasCustomerBanner: ComputedRef<boolean>;
  hasCustomerHeader: ComputedRef<boolean>;
  customerSponsorId: ComputedRef<string>;
  customerWebLink: ComputedRef<string>;
  customerColor: ComputedRef<string>;
  customerMedia: ComputedRef<string>;
  customerBaseline: ComputedRef<string>;
};

export const useCategoryAncestorsCustomer = (
  pAncestors: CategorySchema[] | Ref<CategorySchema[]>
): UseCategoryCustomer => {
  const ancestors = toValue(pAncestors);

  const customerCategory = computed<CategorySchema>(() => {
    return toValue(ancestors).find((cat) => {
      return cat.customerSponsorId && cat.customerMedia && cat.customerBaseline;
    });
  });

  const hasCustomerBanner = computed<boolean>(() => {
    if (!customerCategory.value) return false;
    return customerBaseline.value != null && customerMedia.value != null;
  });

  const hasCustomerHeader = computed<boolean>(() => {
    if (!customerCategory.value) return false;
    return (
      toValue(customerBaseline) != null &&
      toValue(customerCategory)?.media != null
    );
  });

  const customerSponsorId = computed(
    () => customerCategory.value?.customerSponsorId
  );

  const customerWebLink = computed(
    () => customerCategory.value?.customerWebLink
  );

  const customerColor = computed(() => customerCategory.value?.customerColor);

  const customerMedia = computed(() => customerCategory.value?.customerMedia);

  const customerBaseline = computed(
    () => customerCategory.value?.customerBaseline
  );

  return {
    customerCategory,
    hasCustomerBanner,
    hasCustomerHeader,
    customerSponsorId,
    customerWebLink,
    customerColor,
    customerMedia,
    customerBaseline,
  };
};
